import React from 'react';

export type IEditableDataGridContext = {
  ownerGrid?: string;
  hideArchivedLines?: boolean;
  contentWidth?: number;
  onRowSort?: (params: { rowSource: { idx: number }; rowTarget: { idx: number } }) => void;
  hideLinesCondition?: (rowData?: any) => boolean;
  ignoreKeypresses?: boolean;
};

const EditableDataGridContext = React.createContext({ hideArchivedLines: false } as IEditableDataGridContext);
export default EditableDataGridContext;
